(function() {
  if (window.DpPopupMigracaoInitialized) return;
  window.DpPopupMigracaoInitialized = true;

  function initPopup() {
    var root = document.getElementById('DpPopupMigracao');
    if (!root) return;

    var dialog = root.querySelector('.dp-popup-migracao__dialog');
    var closeTriggers = root.querySelectorAll('[data-dp-popup-close]');
    var storageKey = root.getAttribute('data-storage-key') || 'cdm_cafeoteca_popup_seen';
    var delayMs = parseInt(root.getAttribute('data-delay') || '700', 10);
    var lastFocusedElement = null;

    function hasSeenPopup() {
      try {
        return window.localStorage && window.localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    function persistSeen() {
      try {
        if (window.localStorage) {
          window.localStorage.setItem(storageKey, 'true');
        }
      } catch (error) {}
    }

    function closePopup() {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dp-popup-migracao-open');
      document.removeEventListener('keydown', handleEsc);

      if (!root.dataset.dpPopupClicked) {
        persistSeen();
      }

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function handleEsc(event) {
      if (event.key === 'Escape') {
        closePopup();
      }
    }

    function openPopup() {
      if (hasSeenPopup()) return;

      lastFocusedElement = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dp-popup-migracao-open');
      document.addEventListener('keydown', handleEsc);

      var closeButton = root.querySelector('.dp-popup-migracao__close');
      if (closeButton) closeButton.focus();
    }

    closeTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        closePopup();
      });
    });

    if (dialog) {
      dialog.addEventListener('click', function(event) {
        event.stopPropagation();
      });
    }

    root.addEventListener('click', function(event) {
      if (event.target === root || event.target.classList.contains('dp-popup-migracao__overlay')) {
        closePopup();
      }
    });

    var popupLink = root.querySelector('.dp-popup-migracao__link');
    if (popupLink) {
      popupLink.addEventListener('click', function() {
        root.dataset.dpPopupClicked = 'true';
        persistSeen();
      });
    }

    window.setTimeout(openPopup, Math.max(delayMs, 0));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopup, { once: true });
  } else {
    initPopup();
  }
})();
